module.exports = __webpack_public_path__ + "static/media/bigtwo.c898146a.jpeg";